// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"AmountInput_inputContainer__1t77L","input":"AmountInput_input__qrMt-","unit":"AmountInput_unit__DempS"};